let mixins = {}
try {
  // noinspection NpmUsedModulesInstalled
  mixins = require('marketing/giftcards/_mixins/giftcard-form').default
} catch (e) {
  //
}

export default mixins
